module.exports = __webpack_public_path__ + "static/img/certify03.2e9504b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/swiper/images/certify03.png
// module id = KTMr
// module chunks = 1